<template>
    <div class="fadein">
        <div class="h30"></div>
        <transition name="fade">
        <div class="center1200 bg-white temp-1 shadow">
            <div class="h20"></div>
            <div class="center-title">
              <span v-if="movies_length>0"><a href="#"><img class="title-pic" src="/static/img/title-left.png" alt=""> 电影搜索结果：{{keyword}} <img class="title-pic" src="/static/img/title-right.png" alt=""></a></span>
              <span v-else><a href="#"><img class="title-pic" src="/static/img/title-left.png" alt=""> 暂无数据 <img class="title-pic" src="/static/img/title-right.png" alt=""></a></span>
              
            </div>
            <div class="h20"></div>
            <!-- <div v-if="movies_length>0">
                <div class="user-boxes">

                    <div v-for="v in movies" class="user-box">
                        <a href="javascript:;" @click="goUserinfo(v.user_id)" class="username">
                            <img :src="v.user_pic" alt="" class="user-head">

                        <div class="ellipsis">

                                {{v.nickname}}
                            </div>
                        </a>
                        
                    </div>

                </div>
                <div class="h30"></div>
            </div> -->
            <div class="movieboxes" v-if="movies_length>0">
              <div class="moviebox" v-for="v in movies">
                <a href="javascript:;" @click="goMovieDetail(v.id)">
                  <img :src="v.cover" alt="" class="moviepic" />
                </a>
                <a href="" @click="goMovieDetail(v.id)">{{v.title}}</a>
                <p>
                  <span v-for="val in v.withtypes">
                    {{val.type}}
                  </span>
                </p>
              </div>
              <div style="width:172px;" v-for="n in flex_movies_align"></div>
            </div>

            <!-- <div class="forums">
              <div class="forum" v-for="n in 12"><a href="" style="display: block;">category{{n}}</a></div>
            </div> -->
      
            <div class="h10"></div>
      
          </div>
        </transition>
        <div class="h30"></div>
    </div>
</template>
<script>
  export default{
    data(){
      return {
        keyword:'',
        movies:{},
        movies_length:0,
        flex_movies_align:0,
      }
    },
    watch:{
      $route(newVal,oldVal){
        this.movies={}
        if(newVal.name == 'searchmovie'){
          this.$parent.activeIndex = '2'
        }
        this.keyword = this.$route.params.keyword
      },
      keyword(){
        
        this.$parent.activeIndex = '2'
        this.getMovies();
      }
    },
    methods:{
      //根据关键词获取电影
      getMovies(){
        this.keyword = this.$route.params.keyword
        
        $.ajax({
          url:'//'+ this.$API_URL +'/api/v1/movies',
          type:'get',
          data:{keyword:this.keyword},
          success:(ret)=>{
            
            if(ret.data.length>0){
              this.movies = ret.data;
              this.flex_movies_align = 6 - (this.movies.length % 6)
              
            }else{
              // this.movies = "暂无数据"
              this.movies = []
            }
            this.movies_length = this.movies.length
            
          }
        })
      },

      //跳转到用户详情页
      goMovieDetail(id){
        // 
        this.$router.push('/movie/'+id);
        },
      },
    mounted() {
      this.getMovies();
    } 
  }

</script>

<style scoped>
.user-boxes{
    margin:0 20px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-evenly;
    text-align: center;
}
.user-box{
    margin-bottom: 20px;
    width:16%;
    /* height:160px; */
}
.username{
    /* display: block; */
    font-weight: 800;
    font-size:18px;
    color:#3c3c3b;
    text-decoration: none;

    
  }
.ellipsis{

  margin: 5px auto;
    width:160px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.username:hover{
    color:#ff7400;

}
.user-head{
    width:128px;
    height:128px;
    border-radius: 50%;

}

</style>



// WEBPACK FOOTER //
// src/components/index/searchmovie.vue